// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#typography .small-text {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
}
@media (max-width: 660px) {
  #typography .small-text {
    font-size: 9rem;
  }
}
#typography .medium-text {
  color: #fff;
  font-size: 15rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
@media (max-width: 660px) {
  #typography .medium-text {
    font-size: 12rem;
  }
}
#typography .sub-title {
  color: #fff;
  /* H1 Headline */
  font-size: 20rem;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
}
@media (max-width: 660px) {
  #typography .sub-title {
    font-size: 17rem;
  }
}
#anim .reveal[visible] {
  opacity: 1;
  transform: translateX(0) translateY(0) rotate(0deg);
}
li.carousel-item {
  display: inline-block;
  margin-inline-start: 0 !important;
  list-style-type: none !important;
}
li.carousel-item:not(:first-child) {
  margin-inline-start: 32px !important;
}
li.carousel-item img.carousel-img {
  display: block;
  border-radius: 32px;
  margin-bottom: 16px;
  height: 150rem;
}
li.carousel-item p {
  color: #fff;
  /* Text 1 */
  font-size: 12rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2rem;
  width: 260rem;
}
@media (max-width: 660px) {
  li.carousel-item p {
    font-size: 9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/styles/mixins.style.less","webpack://./src/shared/ui/Carousel/ui/CarouselItem/CarouselItem.less"],"names":[],"mappings":"AAAA;EAEQ,WAAA;ECAN,WAAW;EDEL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ACAR;ADEQ;EAAA;IACI,eAAA;ECCV;AACF;ADbA;EAgBQ,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ACAR;ADCQ;EAAA;IACI,gBAAA;ECEV;AACF;ADzBA;EA2BQ,WAAA;ECCN,gBAAgB;EDCV,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACCR;ADAQ;EAAA;IACI,gBAAA;ECGV;AACF;ADUQ;EACI,UAAA;EACA,mDAAA;ACRZ;AAxCA;EACI,qBAAA;EACA,iCAAA;EACA,gCAAA;AA0CJ;AAxCI;EACI,oCAAA;AA0CR;AAhDA;EAUQ,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAyCR;AAtDA;EDAQ,WAAA;ECyDN,WAAW;EDvDL,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;ECWA,aAAA;AA+CR;ADxDQ;EAAA;IACI,eAAA;EC2DV;AACF","sourcesContent":["#typography {\n    .small-text {\n        color: #fff;\n        /* Text 1 */\n        font-size: 12rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 150%;\n        letter-spacing: 0.2rem;\n\n        @media (max-width: 660px) {\n            font-size: 9rem;\n        }\n    }\n\n    .medium-text {\n        color: #fff;\n        font-size: 15rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        @media (max-width: 660px) {\n            font-size: 12rem;\n        }\n    }\n\n    .sub-title {\n        color: #fff;\n        /* H1 Headline */\n        font-size: 20rem;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 32px;\n        @media (max-width: 660px) {\n            font-size: 17rem;\n        }\n    }\n}\n\n#anim {\n    .defaultOpacityTransforms(@delay: 0s, @transform: translateY(0rem)) {\n        transition: 0.6s opacity ease-in-out, 0.6s transform ease-in-out;\n        transition-delay: @delay;\n        transform: @transform;\n        opacity: 0;\n    }\n\n    .reveal {\n        &[visible] {\n            opacity: 1;\n            transform: translateX(0) translateY(0) rotate(0deg);\n        }\n    }\n}","@import 'mixins.style.less';\n\nli.carousel-item {\n    display: inline-block;\n    margin-inline-start: 0 !important;\n    list-style-type: none !important;\n\n    &:not(:first-child) {\n        margin-inline-start: 32px !important;\n    }\n\n    img.carousel-img {\n        display: block;\n        border-radius: 32px;\n        margin-bottom: 16px;\n        height: 150rem;\n    }\n    p {\n        #typography.small-text();\n        width: 260rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
